var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLockinline = function SvgLockinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 15 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#21201F",
    strokeMiterlimit: 10,
    clipPath: "url(#lock_inline_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.906 7.389H1.667c-.67 0-1.214.543-1.214 1.214v9.73c0 .67.544 1.214 1.214 1.214h11.24c.67 0 1.213-.543 1.213-1.214v-9.73c0-.67-.543-1.214-1.214-1.214ZM2.926 6.124V4.883a4.412 4.412 0 1 1 8.824 0v1.191M7.338 11.076v4.394"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "lock_inline_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h14.573v20H0z"
  })))));
};
export default SvgLockinline;